import { render } from "./PlayerTopbar.vue?vue&type=template&id=554ac306&scoped=true"
import script from "./PlayerTopbar.vue?vue&type=script&lang=js"
export * from "./PlayerTopbar.vue?vue&type=script&lang=js"

import "./PlayerTopbar.vue?vue&type=style&index=0&id=554ac306&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554ac306"]])

export default __exports__